const SCROLL_HEIGHT_TOLERANCE = 1;
class MudInfiniteScrollFactory {
    watch(dotNetRef, gridElement) {
        if (!gridElement)
            throw "[MudBlazor | InfiniteScroll] grid element not found";
        if (!gridElement.mudInfiniteScroll)
            gridElement.mudInfiniteScroll = new MudInfiniteScroll();
        gridElement.mudInfiniteScroll.addSentinel(dotNetRef, gridElement);
    }
}
class MudInfiniteScroll {
    constructor() {
        this._sentinelAdded = false;
        this._scrollHeight = 0;
    }

    addSentinel(dotNetObject, gridElement) {
        if (Math.abs(gridElement.scrollHeight - this._scrollHeight) <= SCROLL_HEIGHT_TOLERANCE) {
            return;
        }
        this._scrollHeight = gridElement.scrollHeight;

        if (this._sentinelAdded) {
            return;
        }
        this._sentinelAdded = true;

        const sentinel = document.createElement('div');

        sentinel.style.height = '1px';
        sentinel.style.width = '1px';
        sentinel.style.flexShrink = '0';

        gridElement.appendChild(sentinel);

        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(async (entry) => {
                if (entry.isIntersecting) {
                    this._sentinelAdded = false;
                    observer.unobserve(entry.target);
                    entry.target.remove();
                    dotNetObject.invokeMethodAsync("RaiseScrollEnding");
                }
            });
        }, {
            root: null,
            threshold: 0,
        });

        observer.observe(sentinel);
    }
}

window.mudInfiniteScroll = new MudInfiniteScrollFactory();